import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ActiveTab } from 'sections/onsite-campaigns/context/OnsiteCampaignSectionState';

export const useActiveTab = (): ActiveTab => {
  const location = useLocation();

  const activeTab = useMemo(() => {
    const tabs = {
      workflow: ActiveTab.WORKFLOW_TAB,
      settings: ActiveTab.SETTINGS_TAB,
      performance: ActiveTab.PERFORMANCE_TAB,
    };

    let found: ActiveTab;
    Object.keys(tabs).some(k => {
      if (location.pathname.toLowerCase().search(k) !== -1) {
        found = tabs[k];
        return true;
      }

      return false;
    });

    return found;
  }, [location.pathname]);

  return activeTab;
};
